import { PlansSection, PropertyDataSection, TableFeatures } from './components';

import './index.css';

interface TabsPropertyDataFireProps {
  duplicateId?: number;
  id: number;
}

export const TabsPropertyDataFire = ({
  duplicateId,
  id,
}: TabsPropertyDataFireProps) => {
  return (
    <div className='mt-1'>
      <PlansSection duplicateId={duplicateId} id={id} />

      <PropertyDataSection duplicateId={duplicateId} id={id} />

      <TableFeatures duplicateId={duplicateId} id={id} />
    </div>
  );
};
